import React from 'react';
import styled from '@emotion/styled';
import { PreviewProps } from '../LandingPagePreview';
import BrowserPreview from './BrowserPreview';
import colours from '~/utils/colours';

import { MessageTemplateType } from '~/types/models';

import Postcard from './Desktop/Postcard';
import NextGen from './Desktop/NextGen';

const Container = styled.div`
  position: relative;
  font-size: 18px;
  border: 1px solid #e5e5e5;
  max-width: 1140px;
  width: 90%;
  margin: 0 auto;
  box-shadow: 0px 1px 5px #a09f9f80;

  @media (max-width: 768px) {
    width: 100%;
  }

  @media (max-width: 640px) {
    width: 740px;
  }
`;

const Wrapper = styled.div`
  width: 100%;

  @media (max-width: 640px) {
    overflow-y: scroll;
    border: 2px solid ${colours.blue};
    border-radius: 5px;

    ${Container} {
      margin: 20px;
      display: inline-block;
    }
  }
`;

const PreviewWrapper = styled.div`
  background: #f9f9f9;
  position: relative;
  display: flex;
  height: 100%;
`;

const Desktop = (props: PreviewProps) => {
  const { templateType, canAccessNextGenTemplate } = props;

  return (
    <Wrapper>
      <Container>
        <BrowserPreview height={550}>
          <PreviewWrapper>
            {(!canAccessNextGenTemplate ||
              templateType === MessageTemplateType.Postcard) && (
              <Postcard {...props} />
            )}
            {canAccessNextGenTemplate &&
              templateType === MessageTemplateType.NextGen && (
                <NextGen {...props} />
              )}
          </PreviewWrapper>
        </BrowserPreview>
      </Container>
    </Wrapper>
  );
};

export default Desktop;
